(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-wfc-session-page], [data-wfc-session-product-page]';

  function publishSessionEvent(name, detail) {
    var payload = detail || {};
    payload.page_section = payload.page_section || '';

    window.dispatchEvent(new CustomEvent(name, { detail: payload }));

    // Step 4.5.3: the gtag and dataLayer branches were removed. They emitted
    // session_ete_2026_* names with no send_to, so every one of them fanned out
    // to Google Ads (AW-16688389063) alongside GA4. These are not part of the
    // four approved WFC events, and Shopify/Google already own the ecommerce
    // funnel for this flow. The remaining publishers have no GA4 subscriber.
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(name, payload);
    }
  }

  function generateLineId() {
    var randomPart = '';

    if (window.crypto && window.crypto.getRandomValues) {
      var values = new Uint32Array(2);
      window.crypto.getRandomValues(values);
      randomPart = values[0].toString(36) + values[1].toString(36);
    } else {
      randomPart = Math.random().toString(36).slice(2);
    }

    return 'session-ete-2026-' + Date.now().toString(36) + '-' + randomPart;
  }

  function setUniqueLineId(form) {
    var input = form.querySelector('[data-wfc-session-line-id]');
    if (!input) return;
    input.value = generateLineId();
  }

  function refreshAllLineIds() {
    document.querySelectorAll('[data-wfc-session-line-id]').forEach(function (input) {
      input.value = generateLineId();
    });
  }

  // Stage 2 participant identity. Each entry drives one of the three canonical
  // line-item properties; the messages must stay word-for-word identical to the
  // inline errors in wfc-session-registration-fields.liquid, or the native
  // validation bubble and the inline message contradict each other.
  // Client validation is USABILITY ONLY — the WildFoxApp processor re-validates
  // every field from the HMAC-verified webhook payload and never falls back to
  // purchaser identity.
  var PARTICIPANT_EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  var PARTICIPANT_EMAIL_MAX_LENGTH = 254;

  var PARTICIPANT_FIELDS = [
    {
      field: '[data-wfc-admission-prenom]',
      error: '[data-wfc-admission-prenom-error]',
      message: 'Inscris le prénom du participant.'
    },
    {
      field: '[data-wfc-admission-nom]',
      error: '[data-wfc-admission-nom-error]',
      message: 'Inscris le nom de famille du participant.'
    },
    {
      field: '[data-wfc-admission-courriel]',
      error: '[data-wfc-admission-courriel-error]',
      message: 'Inscris une adresse courriel valide pour le participant.',
      email: true
    }
  ];

  // Must stay word-for-word identical to the inline error in
  // wfc-session-registration-fields.liquid, or the native validation bubble
  // and the inline message contradict each other.
  var TERMS_MESSAGE =
    'Vous devez accepter les conditions des sessions et la politique d’annulation et de remboursement avant d’ajouter l’inscription au panier.';

  // Included-shirt selectors: fulfillment information only. They gate the
  // add-to-cart exactly like the other required admission fields, but their
  // values never reach admission logic (see wfc-session-registration-fields).
  var SHIRT_SELECTS = [
    {
      field: '[data-wfc-admission-shirt-cut]',
      error: '[data-wfc-admission-shirt-cut-error]',
      message: 'Choisis la coupe de ton chandail WFC.'
    },
    {
      field: '[data-wfc-admission-shirt-size]',
      error: '[data-wfc-admission-shirt-size-error]',
      message: 'Choisis la grandeur de ton chandail WFC.'
    }
  ];

  function shirtSelectConfig(field) {
    if (!field || !field.matches) return null;
    for (var i = 0; i < SHIRT_SELECTS.length; i++) {
      if (field.matches(SHIRT_SELECTS[i].field)) return SHIRT_SELECTS[i];
    }
    return null;
  }

  function syncShirtValidity(field, config) {
    if (typeof field.setCustomValidity !== 'function') return;
    field.setCustomValidity(field.value === '' ? config.message : '');
  }

  function participantFieldConfig(field) {
    if (!field || !field.matches) return null;
    for (var p = 0; p < PARTICIPANT_FIELDS.length; p++) {
      if (field.matches(PARTICIPANT_FIELDS[p].field)) return PARTICIPANT_FIELDS[p];
    }
    return null;
  }

  // The email shape check mirrors the backend's conservative pattern exactly.
  // The value is never lowercased here: normalisation is the server's one rule
  // (normalize_wfc_email), and a second client-side rule would diverge from it.
  function syncParticipantValidity(participant, config) {
    if (typeof participant.setCustomValidity !== 'function') return;
    var value = participant.value.trim();
    var invalid = value === '';
    if (!invalid && config.email) {
      invalid = value.length > PARTICIPANT_EMAIL_MAX_LENGTH || !PARTICIPANT_EMAIL_PATTERN.test(value);
    }
    participant.setCustomValidity(invalid ? config.message : '');
  }

  function syncTermsValidity(terms) {
    if (typeof terms.setCustomValidity !== 'function') return;
    terms.setCustomValidity(terms.checked ? '' : TERMS_MESSAGE);
  }

  function setFieldState(field, errorElement, invalid) {
    field.setAttribute('aria-invalid', invalid ? 'true' : 'false');
    if (errorElement) errorElement.hidden = !invalid;
  }

  function formError(field, selector) {
    return field.form ? field.form.querySelector(selector) : null;
  }

  // Seeds the French messages so the very first native bubble is localized,
  // for the initial page and for theme-editor section reloads alike.
  function seedShirtValidity(scope) {
    SHIRT_SELECTS.forEach(function (config) {
      scope.querySelectorAll(config.field).forEach(function (field) {
        syncShirtValidity(field, config);
      });
    });
  }

  function seedParticipantValidity(scope) {
    PARTICIPANT_FIELDS.forEach(function (config) {
      scope.querySelectorAll(config.field).forEach(function (field) {
        syncParticipantValidity(field, config);
      });
    });
  }

  function validateSessionForm(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    var admissionFields = form.querySelector('[data-wfc-admission-fields]');
    if (!admissionFields) return;

    var terms = form.querySelector('[data-wfc-admission-terms]');
    var termsError = form.querySelector('[data-wfc-admission-terms-error]');
    var genericError = form.querySelector('[data-wfc-session-error]');
    var variantError = form.querySelector('[data-wfc-admission-variant-error]');
    var firstInvalid = null;

    if (terms) syncTermsValidity(terms);

    var variantGroup = form.querySelector('[data-wfc-session-variant-group]');
    if (variantGroup) {
      var checkedVariant = variantGroup.querySelector('[data-wfc-session-variant]:checked');
      var firstVariantRadio = variantGroup.querySelector('[data-wfc-session-variant]:not([disabled])');
      var variantInvalid = !checkedVariant && Boolean(firstVariantRadio);
      if (variantError) variantError.hidden = !variantInvalid;
      if (variantInvalid) firstInvalid = firstVariantRadio;
    }

    // Shirt cut/size sit between the course picker and the participant name,
    // so they are checked in that same order for focus and error reporting.
    SHIRT_SELECTS.forEach(function (config) {
      var shirtField = form.querySelector(config.field);
      if (!shirtField) return;
      syncShirtValidity(shirtField, config);
      var shirtInvalid = !shirtField.validity.valid;
      setFieldState(shirtField, form.querySelector(config.error), shirtInvalid);
      if (shirtInvalid && !firstInvalid) firstInvalid = shirtField;
    });

    // The three participant identity fields, in reading order. Whitespace-only
    // values pass the native required check, so every value is trimmed in place
    // before validating — the trimmed value is what Shopify posts.
    PARTICIPANT_FIELDS.forEach(function (config) {
      var participantField = form.querySelector(config.field);
      if (!participantField) return;
      participantField.value = participantField.value.trim();
      syncParticipantValidity(participantField, config);
      var participantInvalid = !participantField.validity.valid;
      setFieldState(participantField, form.querySelector(config.error), participantInvalid);
      if (participantInvalid && !firstInvalid) firstInvalid = participantField;
    });

    if (terms) {
      var termsInvalid = !terms.validity.valid;
      setFieldState(terms, termsError, termsInvalid);
      if (termsInvalid && !firstInvalid) firstInvalid = terms;
    }

    if (!form.checkValidity() || firstInvalid) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (genericError) genericError.hidden = Boolean(firstInvalid);
      if (typeof form.reportValidity === 'function') {
        form.reportValidity();
      } else if (firstInvalid) {
        firstInvalid.focus();
      }
      return;
    }

    if (genericError) genericError.hidden = true;
    setUniqueLineId(form);
    publishSessionEvent('session_ete_2026_add_to_cart', {
      offer_type: form.dataset.offerType || '',
      page_section: form.dataset.pageSection || ''
    });
  }

  // Document-level admission handlers (validation, line-ID lifecycle, tracking)
  // are singletons: they cover every current and future admission form on the
  // page, including forms inside sections reloaded by the Shopify theme
  // editor, and must never be registered twice.
  function initGlobalAdmissionHandlers() {
    if (window.wfcSessionEte2026Init) return;
    window.wfcSessionEte2026Init = true;

    // Line-ID lifecycle: the Liquid-rendered fallback is replaced with a
    // collision-resistant value at load, again on every valid submit (in
    // validateSessionForm, never after a failed validation), and again after
    // Dawn confirms a cart add so a next registration gets a fresh value.
    refreshAllLineIds();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        refreshAllLineIds();
      });
    }

    // Seed the French messages so the very first native bubble is already localized.
    seedParticipantValidity(document);
    document.querySelectorAll('[data-wfc-admission-terms]').forEach(syncTermsValidity);
    seedShirtValidity(document);

    // Native constraint validation (the forms have no novalidate) is the baseline;
    // this listener adds inline errors and keeps the custom messages in sync.
    document.addEventListener(
      'invalid',
      function (event) {
        var field = event.target;
        if (!field || !field.matches) return;

        var invalidParticipant = participantFieldConfig(field);
        if (invalidParticipant) {
          syncParticipantValidity(field, invalidParticipant);
          setFieldState(field, formError(field, invalidParticipant.error), true);
        } else if (field.matches('[data-wfc-admission-terms]')) {
          syncTermsValidity(field);
          setFieldState(field, formError(field, '[data-wfc-admission-terms-error]'), true);
        } else if (field.matches('[data-wfc-session-variant]')) {
          var variantError = formError(field, '[data-wfc-admission-variant-error]');
          if (variantError) variantError.hidden = false;
        } else {
          var invalidShirt = shirtSelectConfig(field);
          if (invalidShirt) {
            syncShirtValidity(field, invalidShirt);
            setFieldState(field, formError(field, invalidShirt.error), true);
          }
        }
      },
      true
    );

    document.addEventListener('input', function (event) {
      var field = event.target;
      var typedParticipant = participantFieldConfig(field);
      if (!typedParticipant) return;
      syncParticipantValidity(field, typedParticipant);
      if (field.validity.valid) {
        setFieldState(field, formError(field, typedParticipant.error), false);
      }
    });

    document.addEventListener('submit', validateSessionForm, true);

    document.addEventListener('change', function (event) {
      var field = event.target;
      if (!field || !field.matches) return;

      if (field.matches('[data-wfc-admission-terms]')) {
        syncTermsValidity(field);
        if (field.validity.valid) {
          setFieldState(field, formError(field, '[data-wfc-admission-terms-error]'), false);
        }
        return;
      }

      var changedShirt = shirtSelectConfig(field);
      if (changedShirt) {
        syncShirtValidity(field, changedShirt);
        if (field.validity.valid) {
          setFieldState(field, formError(field, changedShirt.error), false);
        }
        return;
      }

      if (!field.matches('[data-wfc-session-variant]')) return;

      var scope = field.closest(ROOT_SELECTOR);
      if (scope) {
        var priceTarget = scope.querySelector('[data-wfc-session-price]');
        if (priceTarget && field.dataset.variantPrice) {
          priceTarget.textContent = field.dataset.variantPrice;
        }
      }

      var radioVariantError = formError(field, '[data-wfc-admission-variant-error]');
      if (radioVariantError) radioVariantError.hidden = true;
    });

    document.addEventListener('click', function (event) {
      var tracked = event.target.closest('[data-wfc-session-track]');
      if (tracked) {
        publishSessionEvent('session_ete_2026_' + tracked.dataset.wfcSessionTrack, {
          offer_type: tracked.dataset.offerType || '',
          page_section: tracked.dataset.pageSection || ''
        });
      }

      var checkout = event.target.closest('button[name="checkout"], #CartDrawer-Checkout, #checkout');
      if (checkout && document.querySelector('[data-wfc-session-cart-line]')) {
        publishSessionEvent('session_ete_2026_checkout_click', { page_section: 'cart' });
      }
    });

    if (document.querySelector('[data-wfc-session-cart-line]')) {
      publishSessionEvent('session_ete_2026_cart_view', { page_section: 'cart' });
    }

    if (document.querySelector(ROOT_SELECTOR)) {
      publishSessionEvent('session_ete_2026_view', { page_section: 'landing' });
    }

    // Shopify theme editor: initialize roots inside freshly (re)loaded
    // sections. Old listeners disappear with the replaced DOM, so nothing is
    // double-bound; new instances are picked up here.
    document.addEventListener('shopify:section:load', function (event) {
      initAllSessionRoots(event.target);
      seedParticipantValidity(event.target);
      event.target.querySelectorAll('[data-wfc-admission-terms]').forEach(syncTermsValidity);
      seedShirtValidity(event.target);
      event.target.querySelectorAll('[data-wfc-session-line-id]').forEach(function (input) {
        input.value = generateLineId();
      });
    });
  }

  // Per-instance landing/product UI. Each root owns its offer tabs, panels,
  // sticky CTA, video and observers independently; two landing sections on the
  // same page never share state.
  function initSessionRoot(root) {
    if (!root || root.dataset.wfcSessionInitialized === 'true') return;
    root.dataset.wfcSessionInitialized = 'true';

    var salesEndAt = root.dataset.salesEndAt;
    if (salesEndAt) {
      var salesEndTime = Date.parse(salesEndAt);
      if (!Number.isNaN(salesEndTime) && Date.now() > salesEndTime) {
        root.classList.add('wfc-session--closed');
        root.querySelectorAll('[data-wfc-session-form] button[type="submit"], [data-wfc-session-form] input').forEach(function (element) {
          element.disabled = true;
        });
      }
    }

    var finalPanels = root.querySelectorAll('[data-wfc-session-final-panel]');
    var selectedLabel = root.querySelector('[data-wfc-session-sticky-label]');

    function selectOffer(type, label) {
      root.querySelectorAll('[data-wfc-session-offer]').forEach(function (offer) {
        var isSelected = offer.dataset.offerType === type;
        offer.classList.toggle('is-selected', isSelected);
        offer.setAttribute('aria-current', isSelected ? 'true' : 'false');
      });

      finalPanels.forEach(function (panel) {
        panel.hidden = panel.dataset.offerType !== type;
      });

      if (selectedLabel && label) selectedLabel.textContent = label;

      publishSessionEvent('session_ete_2026_offer_select', {
        offer_type: type,
        page_section: 'offer_selector'
      });
    }

    root.querySelectorAll('[data-wfc-session-select]').forEach(function (button) {
      button.addEventListener('click', function () {
        selectOffer(button.dataset.offerType, button.dataset.offerLabel);
      });
    });

    var offerObserver = null;
    if ('IntersectionObserver' in window) {
      offerObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            publishSessionEvent('session_ete_2026_offer_view', {
              offer_type: entry.target.dataset.offerType || '',
              page_section: 'offer_selector'
            });
            offerObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.45 }
      );

      root.querySelectorAll('[data-wfc-session-offer]').forEach(function (offer) {
        offerObserver.observe(offer);
      });
    }

    root.querySelectorAll('[data-wfc-session-video]').forEach(function (videoBlock) {
      var button = videoBlock.querySelector('[data-wfc-session-video-play]');
      if (!button) return;

      button.addEventListener('click', function () {
        var provider = videoBlock.dataset.provider;
        var videoId = videoBlock.dataset.videoId;
        var iframe = document.createElement('iframe');

        if (!videoId) return;

        if (provider === 'youtube') {
          iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0&modestbranding=1';
        } else if (provider === 'vimeo') {
          iframe.src = 'https://player.vimeo.com/video/' + encodeURIComponent(videoId) + '?autoplay=1';
        } else {
          return;
        }

        iframe.title = button.getAttribute('aria-label') || 'Vidéo Wild Fox Country';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.className = 'wfc-session-video__iframe';
        videoBlock.innerHTML = '';
        videoBlock.appendChild(iframe);
        publishSessionEvent('session_ete_2026_vsl_play', { page_section: 'vsl' });
      });
    });

    var stickyCta = root.querySelector('[data-wfc-session-sticky]');
    var hero = root.querySelector('[data-wfc-session-hero]');
    var purchase = root.querySelector('[data-wfc-session-purchase]');

    if (stickyCta && hero && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyCta.classList.toggle('is-visible', !entry.isIntersecting);
        });
      });
      stickyObserver.observe(hero);
    }

    if (stickyCta && purchase && 'IntersectionObserver' in window) {
      var purchaseObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) stickyCta.classList.remove('is-visible');
        });
      }, { threshold: 0.2 });
      purchaseObserver.observe(purchase);
    }
  }

  // Every root on the page is initialized — never only the first one.
  function initAllSessionRoots(scope) {
    var context = scope || document;
    if (context !== document && context.matches && context.matches(ROOT_SELECTOR)) {
      initSessionRoot(context);
    }
    context.querySelectorAll(ROOT_SELECTOR).forEach(initSessionRoot);
  }

  initGlobalAdmissionHandlers();
  initAllSessionRoots(document);
})();
